
export const COOKIE_POLICY_KEY = 'ALVA_COOKIE_POLICY';

export const setCookiePolicyAccepted = () => {
    if (window.localStorage) {
        window.localStorage.setItem(COOKIE_POLICY_KEY, 'true');
    }
};

export const isCookiePolicyAccepted = () => {
    return !!(window.localStorage && window.localStorage.getItem(COOKIE_POLICY_KEY));
};
